import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      name: '',
    },
  ],
  option: {
    name: '',
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/options?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function options(state = initialState, action) {
  switch (action.type) {
    case types.OPTIONS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.OPTIONS_FETCH_ERROR:
    case types.OPTION_FETCH_ERROR:
    case types.OPTION_EDIT_ERROR:
    case types.OPTION_SET_ERROR:
    case types.OPTION_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.OPTION_FETCH_SUCCESS:
    case types.OPTION_EDIT_SUCCESS:
    case types.OPTION_SET_SUCCESS:
      return assign({}, state, {
        option: action.res,
      });
    case types.OPTION_DELETE_SUCCESS:
      return assign({}, state, {
        optionDelete: action.res.ok,
      });
    case types.OPTIONS_CLEAR_ERRORS:
    case types.OPTION_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default options;



// WEBPACK FOOTER //
// ./src/reducers/options.js